import api from '../config/api';
import { Ticket, PurchaseTicketData, PaginatedResponse } from '../types';

export const ticketService = {
  // Purchase tickets
  purchaseTicket: async (data: PurchaseTicketData): Promise<{
    success: boolean;
    data: {
      tickets?: Ticket[];
      requiresPayment?: boolean;
      paymentData?: {
        provider?: string;
        reference?: string;
        authorizationUrl?: string;
        accessCode?: string;
        url?: string;
        email?: string;
      };
      amountNeeded?: number;
    };
  }> => {
    const response = await api.post('/tickets/purchase', data);
    return response.data;
  },

  // Get user's tickets
  getMyTickets: async (params?: {
    page?: number;
    limit?: number;
    raffleId?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<PaginatedResponse<Ticket>> => {
    const response = await api.get('/tickets/my-tickets', { params });
    return response.data;
  },

  // Get purchase history
  getPurchaseHistory: async (params?: {
    page?: number;
    limit?: number;
  }): Promise<{
    success: boolean;
    data: {
      purchases: any[];
      pagination: {
        page: number;
        limit: number;
        total: number;
        pages: number;
      };
    };
  }> => {
    const response = await api.get('/tickets/purchase-history', { params });
    return response.data;
  },
};
